import { Card } from "../ui/card";
import { Button } from "../ui/button";
import { ClipboardList, Pencil, Trash2, FileDown, Trophy, FileText, Video, NotebookPen, Star } from "lucide-react";
import ShareConvocationMenu from "./ShareConvocationMenu";

function ResultBadge({ scoreUs, scoreThem }) {
  const won = scoreUs > scoreThem;
  const drew = scoreUs === scoreThem;
  const cls = won
    ? "bg-emerald-100 text-emerald-700"
    : drew
    ? "bg-amber-100 text-amber-700"
    : "bg-red-100 text-red-700";
  return (
    <span className={`px-3 py-1 rounded-full text-sm font-bold tabular-nums ${cls}`}>
      {scoreUs}–{scoreThem}
    </span>
  );
}

export default function ConvocationListItem({
  convocation,
  canEdit,
  onEdit,
  onDelete,
  onExportPdf,
  onExportDistinta,
  onOpenResult,
  onOpenReport,
  onOpenRatings,
  players,
  team,
  fields,
}) {
  const c = convocation;
  const callCount = c.player_ids?.length || 0;
  const hasResult = c.final_score_us != null && c.final_score_them != null;
  const hasVeo = !!c.veo_video_url;
  const hasReport = !!(c.report_summary || c.veo_video_url || c.veo_notes);

  return (
    <Card
      className="p-5 border-slate-200 flex items-center gap-4 flex-wrap"
      data-testid={`convocation-${c.id}`}
    >
      <div className="h-12 w-12 rounded-xl bg-emerald-50 text-emerald-600 flex items-center justify-center">
        <ClipboardList size={20} />
      </div>
      <div className="flex-1 min-w-0">
        <div className="font-heading font-semibold text-lg">{c.title}</div>
        <div className="text-sm text-slate-500">
          {c.match_date}
          {c.opponent && ` · vs ${c.opponent}`}
          {c.location && ` · ${c.location}`}
        </div>
      </div>
      {hasResult && (
        <div data-testid={`result-${c.id}`}>
          <ResultBadge scoreUs={c.final_score_us} scoreThem={c.final_score_them} />
        </div>
      )}
      {hasVeo && (
        <a
          href={c.veo_video_url}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-1 px-2 py-1 rounded-full bg-violet-50 text-violet-700 text-xs font-semibold hover:bg-violet-100"
          title="Apri video Veo"
          data-testid={`veo-link-${c.id}`}
        >
          <Video size={12} /> Veo
        </a>
      )}
      <span className="px-3 py-1 rounded-full bg-sky-50 text-sky-700 text-xs font-medium">
        {callCount} convocati
      </span>
      <div className="flex gap-1">
        {canEdit && (
          <Button
            size="sm"
            variant={hasResult ? "outline" : "default"}
            className={hasResult ? "" : "bg-emerald-500 hover:bg-emerald-600"}
            onClick={() => onOpenResult(c)}
            data-testid={`match-result-${c.id}`}
          >
            <Trophy size={14} className="mr-1" /> Risultato
          </Button>
        )}
        {canEdit && onOpenReport && (
          <Button
            size="sm"
            variant={hasReport ? "outline" : "ghost"}
            onClick={() => onOpenReport(c)}
            data-testid={`match-report-${c.id}`}
            title="Report partita + Veo Cam"
          >
            <NotebookPen size={14} className="mr-1" /> Report
          </Button>
        )}
        {canEdit && onOpenRatings && (
          <Button
            size="sm"
            variant="ghost"
            onClick={() => onOpenRatings(c)}
            data-testid={`rate-players-${c.id}`}
            title="Valuta i giocatori (1-10)"
          >
            <Star size={14} className="mr-1" /> Valuta
          </Button>
        )}
        <Button
          size="sm"
          variant="outline"
          onClick={() => onExportPdf(c)}
          data-testid={`export-pdf-${c.id}`}
        >
          <FileDown size={14} className="mr-1" /> PDF
        </Button>
        <Button
          size="sm"
          variant="outline"
          onClick={() => onExportDistinta(c)}
          data-testid={`distinta-${c.id}`}
        >
          <FileText size={14} className="mr-1" /> Distinta
        </Button>
        <ShareConvocationMenu convocation={c} players={players} team={team} fields={fields} />
        {canEdit && (
          <>
            <Button size="icon" variant="ghost" onClick={() => onEdit(c)} aria-label="Modifica">
              <Pencil size={15} />
            </Button>
            <Button size="icon" variant="ghost" onClick={() => onDelete(c)} aria-label="Elimina">
              <Trash2 size={15} className="text-red-500" />
            </Button>
          </>
        )}
      </div>
    </Card>
  );
}
